module.exports = __webpack_public_path__ + "img/elo.a99957ed.svg";